import "./ImprintPage.css";

const imprintSections = [
  {
    title: "Angaben gemäß § 5 DDG",
    content:
      "Lars Hamburger\nEulengasse 15\n60385 Frankfurt am Main\nDeutschland\nE-Mail: getit.lhamb@gmail.com\nWebsite: larshamburger.com",
  },
  {
    title: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    content:
      "Lars Hamburger\nEulengasse 15\n60385 Frankfurt am Main\nDeutschland",
  },
  {
    title: "Haftung für Inhalte",
    content:
      "Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.",
  },
  {
    title: "Haftung für Links",
    content:
      "Diese Website kann Links zu externen Websites Dritter enthalten, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.",
  },
  {
    title: "Urheberrecht",
    content:
      "Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht.",
  },
];

function ImprintPage() {
  return (
    <section className="imprint-page">
      <h1 className="imprint-page__title">Impressum</h1>

      <div className="imprint-page__sections">
        {imprintSections.map((section) => (
          <article key={section.title} className="imprint-page__section">
            <h2 className="imprint-page__section-title">{section.title}</h2>
            <div className="imprint-page__section-content">
              {section.content.split("\n\n").map((paragraph, index) => (
                <p key={`${section.title}-${index}`}>{paragraph}</p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ImprintPage;
